






































































import {
  ConfirmModalState, WithMultipleConfirmModal } from '@/components/organisms/confirm-modal/with-multiple-confirm-modal'
// @ts-ignore
import ConfirmModal from '@/components/organisms/ConfirmModal.vue'
import { WithErrorModal } from '@/components/organisms/dialog/error-dialog/with-error-modal'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { log } from '@/log'
import CrossPageTransition from '@/mixin/cross-page-transition'
import { ApiCreditcard } from '@/models/api/creditcard'
import { stringifyErrorForEndUser } from '@/models/paid-membership/subscribe/errors'
// @ts-ignore
import { ActionRequest } from '@/models/payment/creditcard/action/action' // ts3.8以降であればimport typeが利用可能
import { WithCreditcardForSubscriptionRepository } from '@/models/payment/creditcard/context/for-subscription/mixin'
import {
  changeCreditcardForSubscription
} from '@/models/payment/creditcard/context/for-subscription/service/change-creditcard'
import {
  CreditcardRegistrationDependencies, registerNewCreditcard,
} from '@/models/payment/creditcard/service/register-new-creditcard'
import TitleSection from '@spa/components/atoms/TitleSection.vue'
import { ExtraProfileFormState } from '@spa/components/organisms/paid-membership/creditcard-extra-profile/ExtraProfile.vue'
import NewCreditcard, { RegisterCreditcardEmit } from '@spa/components/organisms/paid-membership/NewCreditcard.vue'
import ShowCreditcard from '@spa/components/organisms/paid-membership/ShowCreditcard.vue'
import CreditcardForm from '@spa/components/organisms/payment/creditcard/CreditcardForm.vue'
import SpaCreditCardDescription from '@spa/components/organisms/payment/description/CreditCardDescription.vue'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { CallbackErrorMessageParse, ThreeDSecureResultPageMixin } from '@spa/mixins/three-d-secure-result-page'
import { User } from '@spa/store/modules/user/types'
import { none, Option, some } from 'fp-ts/lib/Option'
import _ from 'lodash'
import Vue from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop, Provide } from 'vue-property-decorator'
import { defaultNextPage, NextPageAfterCardRegistration } from './model/change-creditcard/next-page'

type MixedIn = PluginMixin
  & CrossPageTransition
  & WithCreditcardForSubscriptionRepository
  & ThreeDSecureResultPageMixin
  & WithErrorModal
  & WithMultipleConfirmModal

@Component({
  components: {
    TitleSection,
    ConfirmModal,
    CreditcardForm,
    SpaErrorDialog,
    SpaCreditCardDescription,
    ShowCreditcard,
    NewCreditcard,
  },
  mixins: [
    LoadingMixin,
    ThreeDSecureResultPageMixin,
    WithMultipleConfirmModal,
  ],
})
export default class ChangeCreditCard extends
  Mixins<MixedIn>(
    PluginMixin,
    CrossPageTransition,
    WithCreditcardForSubscriptionRepository,
    WithErrorModal,
    WithMultipleConfirmModal,
    ThreeDSecureResultPageMixin
  ) {

  multipleConfirmModalState: ConfirmModalState[] = [
    ConfirmModalState.initial(ConfirmModalKey.BeforeRegister),
    ConfirmModalState.initial(ConfirmModalKey.RegisterSuccess),
  ]

  @Prop({ required: true })
  readonly creditcardRegistrationDependencies: CreditcardRegistrationDependencies

  @Prop({ default: () => defaultNextPage })
  /**
   * このpropは、最終的に削除の可能性が高い.
   * @see NextPageAfterCardRegistration
   */
  readonly nextPage: NextPageAfterCardRegistration

  /**
   * このpropは、最終的に削除の可能性が高い.
   * @see NextPageAfterCardRegistration
   */
  @Prop({ default: '更新' })
  readonly context: '更新' | '登録'

  @Prop({ default: null })
  readonly subCompleteMessage: Vue | null

  @Provide() // 下位コンポーネント全体でvalidatorを共有するために必須
  readonly $validator

  status: Status = Status.Pending

  creditCard: Option<ApiCreditcard> = none

  async created() {
    this.status = Status.Loading

    try {
      await this.initOrElseRedirectUser()
      await this.creditCardForSubscriptionRepository.findRegistered().then((card) => {
        this.creditCard = card
      })
    } catch (error) {
      this.handleError(error)
    } finally {
      this.status = Status.Pending
    }

    this.handleThreeDSecureCallbackSuccess()
    this.handleThreeDSecureCallbackError()
  }

  get user(): User {
    return this.$store.state.user.user
  }

  /**
   * @override
   * @see LoadingMixin.isLoading
   */
  get isLoading() {
    return this.status === Status.Loading
  }
  get isCompleted() {
    return this.status === Status.Completed
  }

  get headingIconUrl(): string {
    return '/assets-proxy/images/common/icon/exclamation.svg'
  }

  get confirmModalKeys(): typeof ConfirmModalKey {
    return ConfirmModalKey
  }

  get defaultExtraProfileFormState(): ExtraProfileFormState {
    return {
      buyerNameKanji: `${this.user.last_name || ''}${this.user.first_name || ''}`,
      buyerEmail: this.user.email || '',
      buyerTel: this.user.tel || '',
    }
  }

  async initOrElseRedirectUser(): Promise<void> {
    await this.$store.dispatch('user/get')

    const errorOnGet = _.get(this.user, 'error.get')

    if (errorOnGet) {
      log.warn(`redirect to auth page because error happened in getting user status`, errorOnGet)

      return this.$router.push('/paid-membership/subscribe/login')
    }

    if (!this.user || this.user.user_status !== 'registered') {
      log.warn(`redirect to auth page because user not registered`, this.user)

      return this.$router.push('/paid-membership/subscribe/login')
    }
  }

  async replace({ creditcardFormState, extraProfileFormState }: RegisterCreditcardEmit) {
    await this.confirm(ConfirmModalKey.BeforeRegister)
      .then((confirmed) => {
        if (!confirmed) return // キャンセルボタンなしで運用しているため、ここが発火することはない想定
        this.removeTheeDSecureResultQueryParams()
      })

    this.status = Status.Loading

    try {
      await this.creditCard.foldL(
        /**
         * LP用有料会員プラン契約フォームの実装を簡略化するためにこのVueコンポーネントを再利用している関係で、
         * クレジットカード未登録の場合でも処理する必要がある.
         *
         * クレジットカード登録の処理がLP用フォームで完結するようになったら、
         * この画面は「変更」専用として、クレジットカード未登録のケースはエラー扱いにしても良い.
         *
         * @see NextPageAfterCardRegistration
         * @see https://github.com/my-color/front/issues/6682
         * @see https://github.com/my-color/front/pull/6759
         */
        /**
         * 戻り値がPromise<void>であるように、登録・変更結果を直接受け取ってはいない。
         * 3Dセキュアでのリダイレクトのように結果を受け取るためには再びGPの画面を描写すればいい場合は問題にならないが、
         * それ以外にも結果に基づいてこのメソッドから何らかの処理を指示したい場合は、ここに後続処理を記述するのではなく、フックを注入すること。
         * @see ActionRequest
         */
        () => registerNewCreditcard(
          this.creditcardRegistrationDependencies,
          creditcardFormState,
          this.user,
          {
            enableSubProcess: true,
            threeDSecureRedirectUrl: some(new URL(window.location.href)),
            threeDSecureExtraProfile: some(extraProfileFormState),
          }
        ),
        selectedCard => changeCreditcardForSubscription(
          this.creditCardForSubscriptionRepository,
          {
            creditcard: {
              oldCard: selectedCard,
              newCard: creditcardFormState,
            },
          },
          this.user,
          {
            enableSubProcess: true,
            threeDSecureRedirectUrl: some(new URL(window.location.href)),
            threeDSecureExtraProfile: some(extraProfileFormState),
          }
        )
      )

      this.status = Status.Completed
    } catch (e) {
      this.handleError(e)
    }
  }

  handleErrorDialogClose() {
    this.closeModal()
    this.removeTheeDSecureResultQueryParams()
  }

  private handleError(e) {
    log.error(e)

    this.onError({
      content: stringifyErrorForEndUser(e),
    })
    this.status = Status.Pending
  }

  private handleThreeDSecureCallbackSuccess(): void {
    if (this.threeDSecureCallbackSuccess) {
      this.status = Status.Completed
    }
  }

  private handleThreeDSecureCallbackError(): void {
    const errorMessage = new CallbackErrorMessageParse().parse(
      this.threeDSecureCallbackErrorType,
      this.threeDSecureCallbackErrorCode,
      this.threeDSecureCallbackErrorCredit,
      this.threeDSecureCallbackErrorMessage
    )

    if (!errorMessage) return

    this.onError({
      content: errorMessage,
    })
  }
}

enum ConfirmModalKey {
  BeforeRegister = 'before-register',
  RegisterSuccess = 'register-success',
}
